/* eslint-disable no-magic-numbers */
export const clampBelow = (value, clampAt) => {
    return value < clampAt ? clampAt : value;
};
export const clampAbove = (value, clampAt) => {
    return value > clampAt ? clampAt : value;
};
export const clampBetween = (value, clampBelowAt, clampAboveAt) => {
    return clampBelow(clampAbove(value, clampAboveAt), clampBelowAt);
};
export const clampBelowAtZero = (value) => clampBelow(value, 0);
//# sourceMappingURL=clamp.js.map